// src/App.jsx
import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar.jsx";
import Topbar from "./components/Topbar.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import Home from "./pages/Home.jsx";
import Feedback from "./pages/Feedback.jsx";

// NEW: Landing
import Landing from "./pages/Landing.jsx";

// GT3 Xperience
import Overview from "./pages/gt3x/Overview.jsx";
import Schedule from "./pages/gt3x/Schedule.jsx";
import Rules from "./pages/gt3x/Rules.jsx";
import Briefing from "./pages/gt3x/Briefing.jsx";
import Rennabmeldung from "./pages/gt3x/Rennabmeldung.jsx";
import RegisterForm from "./pages/gt3x/Register.jsx";       // „Anmelden“
import RegisterList from "./pages/gt3x/RegisterList.jsx";   // „Anmeldeliste“
import StandingsPro from "./pages/gt3x/StandingsPro.jsx";
import StandingsInt from "./pages/gt3x/StandingsInt.jsx";
import StandingsAm from "./pages/gt3x/StandingsAm.jsx";
import StandingsTeam from "./pages/gt3x/StandingsTeam.jsx";
import StandingsMarken from "./pages/gt3x/StandingsMarken.jsx";
import Lizenz from "./pages/gt3x/Lizenz.jsx";
import Results from "./pages/gt3x/Results.jsx";
import Incidents from "./pages/gt3x/Incidents.jsx";
import Protest from "./pages/gt3x/Protest.jsx";
import Streamer from "./pages/gt3x/Streamer.jsx";
import Overlay from "./pages/gt3x/Overlay.jsx";

// Polls (NEW)
import ManagerPolls from "./pages/manager/admin/ManagerPolls.jsx";
import PollsAdminPage from "./pages/polls/PollsAdminPage";
import PollsRoomPage from "./pages/polls/PollsRoomPage.jsx";
import PollsOverlayPage from "./pages/polls/PollsOverlayPage.jsx";

// DRIVERPROFILE
import DriverProfileRoute from "./pages/gt3x/DriverProfileRoute.jsx";

// Login AUTH - Admin Panels
import Login from "./pages/Login.jsx";
import DiscordCallback from "./pages/DiscordCallback";
import RequireAdmin from "./auth/RequireAdmin.jsx";
import RequireAuth from "./auth/RequireAuth.jsx";
import RequireReko from "./auth/RequireReko.jsx";
import RequireRekoAccess from "./auth/RequireRekoAccess.jsx";
import RequireOrgaAccess from "./auth/RequireOrgaAccess.jsx";
import ManagerAdminHome from "./pages/manager/admin/ManagerAdminHome.jsx";
import StandingsImportPanel from "./pages/manager/admin/StandingsImportPanel.jsx";
import StandingsImportSingleClassPanel from "./pages/manager/admin/StandingsImportSingleClassPanel.jsx";
import DriverManagement from "./pages/manager/DriverManagement.jsx";
import TeamManagement from "./pages/manager/TeamManagement.jsx";
import ResultsImport from "./pages/manager/orga/ResultsImport.jsx";
import SeasonManagement from "./pages/manager/admin/SeasonManagement.jsx";
import UserManagement from "./pages/manager/admin/UserManagement.jsx";
import AssetManagement from "./pages/manager/admin/AssetManagement.jsx";
import DriverClass from "./pages/manager/admin/DriverClass.jsx";
import RulebookManagement from "./pages/manager/admin/RulebookManagement.jsx";
import OfftrackManagement from "./pages/manager/admin/OfftrackManagement.jsx";

// Userbereich
import UserDashboard from "./pages/user/UserDashboard.jsx";
import UserProfile from "./pages/user/UserProfile.jsx";
import UserRegister from "./pages/user/UserRegister.jsx";

// ReKo Bereich
import RekoDashboard from "./pages/reko/RekoDashboard.jsx";
import RekoIncidents from "./pages/reko/RekoIncidents.jsx";
import RekoKnowledge from "./pages/reko/RekoKnowledge.jsx";

// Import Archive
import ArchiveSeasonHome from "./pages/gt3x/archive/ArchiveSeasonHome.jsx";
import ArchiveSeasonResultsDb from "./pages/gt3x/archive/ArchiveSeasonResultsDb.jsx";
import ArchiveSeasonIncidentsDb from "./pages/gt3x/archive/ArchiveSeasonIncidentsDb.jsx";
import ArchiveSeasonStandingsProDb from "./pages/gt3x/archive/ArchiveSeasonStandingsProDb.jsx";
import ArchiveSeasonStandingsIntDb from "./pages/gt3x/archive/ArchiveSeasonStandingsIntDb.jsx";
import ArchiveSeasonStandingsAmDb from "./pages/gt3x/archive/ArchiveSeasonStandingsAmDb.jsx";
import ArchiveSeasonStandingsTeamDb from "./pages/gt3x/archive/ArchiveSeasonStandingsTeamDb.jsx";
import ArchiveSeasonStandingsBrandDb from "./pages/gt3x/archive/ArchiveSeasonStandingsBrandDb.jsx";
import ArchiveSeasonLizenzDb from "./pages/gt3x/archive/ArchiveSeasonLizenzDb.jsx";

// Platzhalter weitere Serie
import GTEX from "./pages/gtex/OverviewGTEX.jsx";
import GT4X from "./pages/gt4x/OverviewGT4X.jsx";

// Special Xperience
import SpecialXOverview from "./pages/specialx/OverviewSpecialX.jsx";
import SpecialXRegister from "./pages/specialx/RegisterSpecialX.jsx";
import SpecialXRegisterList from "./pages/specialx/RegisterListSpecialX.jsx";
import SpecialXSchedule from "./pages/specialx/ScheduleSpecialX.jsx";
import SpecialXStreamer from "./pages/specialx/StreamerSpecialX.jsx";
import SpecialXResults from "./pages/specialx/ResultsSpecialX.jsx";
import SpecialXStandings from "./pages/specialx/StandingsSpecialX.jsx";
import SpecialXRules from "./pages/specialx/RulesSpecialX.jsx";

import Footer from "./components/Footer.jsx";

export default function App() {
    const location = useLocation();
    const isLanding = location.pathname === "/";

    // Root „/“ soll ein Full-Bleed Layout ohne Sidebar/Topbar sein
    if (isLanding) {
        return (
            <div className="app-landing">
                <Routes>
                    <Route path="/" element={<Landing />} />
                    {/* Fallback → Landing */}
                    <Route path="*" element={<Landing />} />
                </Routes>
            </div>
        );
    }


    // Standardlayout (Liga Manager & alle Unterseiten)
    const closeSidebar = () => {
        document.body.classList.remove("sidebar-open");
    };

    return (
        <div className="app">
            <ScrollToTop targetSelector=".main" />
            <Sidebar />
            {/* Overlay (nur aktiv, wenn body.sidebar-open) */}
            <div
                className="sidebar-overlay"
                onClick={closeSidebar}
                role="presentation"
            />
            <main className="main">
                <Topbar />
                <div className="content">
                    <Routes location={location}>
                        {/* ALT: Home war hier; jetzt unter /manager */}
                        <Route path="/manager" element={<Home />} />

                        <Route
                            path="/manager/admin"
                            element={
                                <RequireAdmin>
                                    <ManagerAdminHome />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/polls"
                            element={
                                <RequireAdmin>
                                    <ManagerPolls />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/driver-class"
                            element={
                                <RequireAdmin>
                                    <DriverClass />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/import"
                            element={
                                <RequireAdmin>
                                    <StandingsImportPanel />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/import-single"
                            element={
                                <RequireAdmin>
                                    <StandingsImportSingleClassPanel />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/drivers"
                            element={
                                <RequireAdmin>
                                    <DriverManagement />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/teams"
                            element={
                                <RequireAdmin>
                                    <TeamManagement />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/seasons"
                            element={
                                <RequireAdmin>
                                    <SeasonManagement />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/users"
                            element={
                                <RequireAdmin>
                                    <UserManagement />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/assets"
                            element={
                                <RequireAdmin>
                                    <AssetManagement />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/results-import"
                            element={
                                <RequireAdmin>
                                    <ResultsImport />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/rulebook"
                            element={
                                <RequireAdmin>
                                    <RulebookManagement />
                                </RequireAdmin>
                            }
                        />

                        <Route
                            path="/manager/admin/offtrack"
                            element={
                                <RequireAdmin>
                                    <OfftrackManagement />
                                </RequireAdmin>
                            }
                        />

                        {/* Userbereich */}
                        <Route
                            path="/manager/user"
                            element={
                                <RequireAuth>
                                    <UserDashboard />
                                </RequireAuth>
                            }
                        />

                        <Route
                            path="/manager/user/profile"
                            element={
                                <RequireAuth>
                                    <UserProfile />
                                </RequireAuth>
                            }
                        />

                        <Route
                            path="/manager/user/registrieren"
                            element={
                                <RequireAuth>
                                    <UserRegister />
                                </RequireAuth>
                            }
                        />

                        {/* ReKo Bereich */}
                        <Route
                            path="/manager/reko"
                            element={
                                <RequireReko>
                                    <RekoDashboard />
                                </RequireReko>
                            }
                        />

                        <Route
                            path="/manager/reko/incidents"
                            element={
                                <RequireRekoAccess>
                                    <RekoIncidents />
                                </RequireRekoAccess>
                            }
                        />

                        <Route
                            path="/manager/reko/knowledge"
                            element={
                                <RequireRekoAccess>
                                    <RekoKnowledge />
                                </RequireRekoAccess>
                            }
                        />

                        {/* Orga Bereich */}
                        <Route
                            path="/manager/orga/incidents"
                            element={
                                <RequireOrgaAccess>
                                    <RekoIncidents />
                                </RequireOrgaAccess>
                            }
                        />

                        <Route
                            path="/manager/orga/drivers"
                            element={
                                <RequireOrgaAccess>
                                    <DriverManagement />
                                </RequireOrgaAccess>
                            }
                        />

                        <Route
                            path="/manager/orga/teams"
                            element={
                                <RequireOrgaAccess>
                                    <TeamManagement />
                                </RequireOrgaAccess>
                            }
                        />

                        <Route
                            path="/manager/orga/results"
                            element={
                                <RequireOrgaAccess>
                                    <ResultsImport />
                                </RequireOrgaAccess>
                            }
                        />

                        <Route
                            path="/manager/orga/results-import"
                            element={
                                <RequireOrgaAccess>
                                    <ResultsImport />
                                </RequireOrgaAccess>
                            }
                        />

                        <Route path="/feedback" element={<Feedback />} />

                        {/* GT3 Xperience */}
                        <Route path="/gt3x/overview" element={<Overview />} />
                        <Route path="/gt3x/schedule" element={<Schedule />} />
                        <Route path="/gt3x/rules" element={<Rules />} />
                        <Route path="/gt3x/briefing" element={<Briefing />} />
                        <Route path="/gt3x/rennabmeldung" element={<Rennabmeldung />} />
                        <Route path="/stats/:driverSlug" element={<DriverProfileRoute />} />
                        <Route path="/gt3x/streamer" element={<Streamer />} />
                        <Route path="/gt3x/overlay" element={<Overlay />} />

                        {/* Anmeldung – direkt */}
                        <Route path="/gt3x/anmeldung/anmelden" element={<RegisterForm />} />
                        <Route path="/gt3x/anmeldung/anmeldeliste" element={<RegisterList />} />

                        {/* Standings */}
                        <Route path="/gt3x/standings/pro" element={<StandingsPro />} />
                        <Route path="/gt3x/standings/int" element={<StandingsInt />} />
                        <Route path="/gt3x/standings/am" element={<StandingsAm />} />
                        <Route path="/gt3x/standings/team" element={<StandingsTeam />} />
                        <Route path="/gt3x/standings/marken" element={<StandingsMarken />} />

                        <Route path="/gt3x/lizenz" element={<Lizenz />} />
                        <Route path="/gt3x/ergebnisse" element={<Results />} />
                        <Route path="/gt3x/incidents" element={<Incidents />} />
                        <Route path="/gt3x/reports" element={<Incidents />} />
                        <Route path="/gt3x/protest" element={<RequireAuth><Protest /></RequireAuth>} />

                        {/* DB Archive */}
                        <Route path="/gt3x/archiv/:seasonKey" element={<ArchiveSeasonHome />} />
                        <Route path="/gt3x/archiv/:seasonKey/results" element={<ArchiveSeasonResultsDb />} />
                        <Route path="/gt3x/archiv/:seasonKey/incidents" element={<ArchiveSeasonIncidentsDb />} />
                        <Route path="/gt3x/archiv/:seasonKey/standings/pro" element={<ArchiveSeasonStandingsProDb />} />
                        <Route path="/gt3x/archiv/:seasonKey/standings/int" element={<ArchiveSeasonStandingsIntDb />} />
                        <Route path="/gt3x/archiv/:seasonKey/standings/am" element={<ArchiveSeasonStandingsAmDb />} />
                        <Route path="/gt3x/archiv/:seasonKey/standings/team" element={<ArchiveSeasonStandingsTeamDb />} />
                        <Route path="/gt3x/archiv/:seasonKey/standings/marke" element={<ArchiveSeasonStandingsBrandDb />} />
                        <Route path="/gt3x/archiv/:seasonKey/lizenz" element={<ArchiveSeasonLizenzDb />} />

                        {/* weitere Serie */}
                        <Route path="/gtex" element={<GTEX />} />
                        <Route path="/gt4x" element={<GT4X />} />

                        {/* Special Xperience */}
                        <Route path="/specialx/overview" element={<SpecialXOverview />} />
                        <Route path="/specialx/anmeldung/anmelden" element={<SpecialXRegister />} />
                        <Route path="/specialx/anmeldung/anmeldeliste" element={<SpecialXRegisterList />} />
                        <Route path="/specialx/schedule" element={<SpecialXSchedule />} />
                        <Route path="/specialx/streamer" element={<SpecialXStreamer />} />
                        <Route path="/specialx/standings" element={<SpecialXStandings />} />
                        <Route path="/specialx/results" element={<SpecialXResults />} />
                        <Route path="/specialx/rules" element={<SpecialXRules />} />

                        {/* Polls */}
                        <Route
                            path="/polls/admin"
                            element={
                                <RequireOrgaAccess>
                                    <PollsAdminPage />
                                </RequireOrgaAccess>
                            }
                        />
                        <Route path="/polls/room" element={<PollsRoomPage />} />
                        <Route path="/polls/overlay" element={<PollsOverlayPage />} />

                        <Route path="/login" element={<Login />} />
                        <Route path="/auth/discord/callback" element={<DiscordCallback />} />

                        {/* Fallback → Liga Manager */}
                        <Route path="*" element={<Home />} />
                    </Routes>
                </div>
                <Footer />
            </main>
        </div>
    );
}
